/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { eventService } from '../../../services/event.service'
import { ModalReservation } from '../../../components/Events/ModalReservation'
import { Faqs } from '../../../components/Events/Faqs'

import { reservationService } from '../../../services/reservation.service'
import { useAuth } from '../../../hooks/useAuth'
import './style.scss'
import { Helmet } from 'react-helmet-async'

export const EventDetail = () => {
  console.log(document.title)
  const { idEvento } = useParams()
  const [event, setEvent] = useState({})
  const navigate = useNavigate()
  const [title, setTitle] = useState('RAARR | Evento')

  useEffect(() => {
    const getEvent = async () => {
      try {
        const eventData = await eventService.getOneEvent(idEvento)
        setEvent(eventData)
        setTitle(eventData.eventData.nombre)
      } catch (error) {
        console.error(error.response.status)
        setEvent(null)
      }
    }
    const updateEvent = () => {
      event.boletos?.map(boleto => {
        boleto.precio = parseFloat(boleto.precio)
        return boleto
      })
    }
    getEvent()
    updateEvent()
  }, [idEvento, title])

  function getId (url) { // a partir de aquí se revisa la url del video y se obtiene el ID del video, le puse un type OF porque al principio se muestra en la consola que el ID es undefined y después si se muestra, creo que es el tiempo de carga.
    if (typeof url !== 'undefined') {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
      const match = url.match(regExp)
      return (match && match[2].length === 11)
        ? match[2]
        : null
    }
  }
  const videoId = getId((event.eventData?.video))
  const youtubeEmbed = 'https://www.youtube.com/embed/' + videoId + '?modestbranding=1&rel=0&iv_load_policy=3&controls=0'

  if (event === null) return navigate('/recurso-no-encontrado')

  if (event.eventData?.nombre.length > 0) {
    return (
      <>
          <Helmet>
            <title>{title}</title>
            <meta name="description" content='RAARR | Evento' />
          </Helmet>
          <div className="background-image" style={ { backgroundImage: `url(${event.eventData?.foto_portada})` } }/>
          <section className="container mt-2 mt-lg-4 mt-xl-5">
            <div className="row">
              <EventBody event={event} youtubeEmbed={youtubeEmbed} />
              <Sidebar event={event}/>
            </div>
          </section>
        </>
    )
  }
}

const EventBody = ({ event, youtubeEmbed }) => {
  return (
    <>
    <div className="col-xl-7 col-lg-8 col-md-7 order-md-1 mb-5">
        <div className="card_descripcion">
          <h2 className="h1 pb-md-2 pb-lg-3">{event.eventData?.nombre_artista}</h2>
          <h4 id="nombre_evento">{event.eventData?.nombre}</h4>
          <h5>{event.eventData?.fecha_funcion} {event.eventData?.hora_inicio}</h5>
          <p className="pb-4 mb-3">
            {event.eventData?.descripcion}
          </p>
        </div>
        <div className="card_descripcion">
          <h3 id="ubicacion" className="mb-4">Detalles de ubicación</h3>
          <ul className="list-unstyled mb-5">
            <li className="d-flex align-items-center mb-2">
              <b>Ciudad: {event.eventData?.ciudad}</b>
            </li>
            <li className="d-flex align-items-center mb-2">
              <b>Estado: {event.eventData?.estado}</b>
            </li>
            <li className="d-flex align-items-center mb-2">
              <b>Lugar: {event.eventData?.ubicacion}</b>
            </li>
            <li className="d-flex align-items-center mb-2 flex-wrap">
              <b>Dirección: {event.eventData?.direccion}</b>
            </li>
          </ul>
        </div>
        <div className="mt-n3 mb-2" width="560" height="315" />
        <div className="youtube_video">
          <iframe
            width="560" height="420" src={youtubeEmbed} title="YouTube video player" frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen>
          </iframe>
        </div>
        <Faqs />
      </div></>
  )
}

const Sidebar = ({ event }) => {
  const [ticketCount, setTicketCount] = useState(1)
  const [funcion, setFuncion] = useState('')
  const [ticket, setTicket] = useState('')
  const [ticketValue, setTicketValue] = useState({})
  const [functionValue, setFunctionValue] = useState({})

  const [isLoading, setIsLoading] = useState(false)
  const auth = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    // Al iniciar el componente, se verifica si hay boletos y/o funciones
    // y se agregar el primer valor de la lista al estado, que luego
    // podrá ser cambiado por el usuario desde la interfáz

    // Al cambiar este valor, recibimos un json en string, lo transformamos
    // a objeto y lo guardamos en ticketValue y functionValue

    if (event?.boletos?.length > 0 && ticket === '') {
      setTicket(JSON.stringify(event.boletos[0]))
    }
    if (event?.showtimes?.length > 0 && funcion === '') {
      setFuncion(JSON.stringify(event.showtimes[0]))
    }
    if (ticket !== '') setTicketValue(JSON.parse(ticket))
    if (funcion !== '') setFunctionValue(JSON.parse(funcion))
  }, [event, ticket, funcion])

  // Si el usuario no ha iniciado sesion no podrá reservar
  const handleReservation = async () => {
    try {
      setIsLoading(true)
      const reservaDataToPost = {
        fecha_funcion: functionValue.fecha_funcion,
        hora_inicio: functionValue.hora_inicio,
        id_usuario: auth.user.uid,
        id_evento: event.eid,
        id_funcion: functionValue.id_funcion_fk,
        id_boleto: ticketValue.bid,
        cantidad_boletos: parseInt(ticketCount),
        paymentIntent: 'Gratis'
      }

      console.log(reservaDataToPost)

      await reservationService.createReservation(reservaDataToPost)

      return navigate(`/reserva/${event.eid}`)
    } catch (error) {
      setIsLoading(false)
      console.log(error)
    }
  }

  return (
    <aside className="col-lg-4 col-md-5 offset-xl-1 order-md-2 mb-5">
      <div style={{ marginTop: '-96px' }} />
      <div className="position-sticky top-0 pt-5">
        <div className="pt-5 mt-md-3">
          <div className="card-event2">
            <div className="img-wrapper2">
              <img id="foto_portada_evento"src={event.eventData?.foto_portada} className="square card-img-top" />
            </div>
          </div>
        </div>
          <form>
            <div className='row-div'>
              {
                event.boletos?.length > 0
                  ? (
                    <div className='ticket'>
                      <p>Tipo de Boleto</p>
                      <select
                      className="ticket_dropdown"
                      value={ticket}
                      onChange={(e) => setTicket(e.target.value)}
                      placeholder="Selecciona el boleto"
                    >
                      {event?.boletos?.map(b => (
                        <option
                          className='ticket_dropdown_option'
                          key={b.bid}
                          value={JSON.stringify(b)}
                        >
                          {b.nombre_tipo_boleto + ' - ' + b.precio}
                        </option>
                      ))}
                    </select>
                    </div>
                    )
                  : <></>
              }
              {
                event?.showtimes?.length > 0
                  ? (
                    <div className='function'>
                      <p>Función</p>
                      <select
                        className="function_dropdown"
                        value={funcion}
                        onChange={(e) => setFuncion(e.target.value)}
                        placeholder="Selecciona la funcion"
                      >
                        {event?.showtimes?.map(b => (
                          <option
                            className='ticket_dropdown_option'
                            key={b.id_funcion_fk}
                            value={JSON.stringify(b)}
                          >
                            {b.fecha_funcion + ' - ' + b.hora_inicio}
                          </option>
                        ))}
                      </select>
                    </div>
                    )
                  : <></>
              }
              <select className="quantity_dropdown" value={ticketCount} onChange={(e) => setTicketCount(e.target.value)}>
                  {Array.from({ length: 10 }, (_, i) => i + 1).map(num => (
                      <option className='ticket_dropdown_option' key={num} value={num}>{num + ' Tickets'}</option>
                  ))}
              </select>
              {
                auth.isAuthenticated
                  ? (
                  <>
                    {
                      ticketValue.precio > 0 && event.boletos?.length > 0
                        ? (
                            <button
                              className="checkout_button"
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#modalReserve"
                              data-bs-whatever="@mdo"
                            >
                              Continuar
                            </button>
                          )
                        : (
                          <button
                            className='checkout_button'
                            type="button"
                            disabled={isLoading}
                            onClick={() => {
                              handleReservation()
                            }}
                          >
                            <span id='button-text'>
                              {isLoading ? <div className='spinner' id='spinner'></div> : 'Reservar'}
                            </span>
                          </button>
                          )
                    }
                  </>
                    )
                  : (
                    <button
                      className='checkout_button'
                      type="button"
                      onClick={() => {
                        navigate('/iniciar-sesion')
                      }}
                    >
                      Continuar
                    </button>
                    )
              }
            </div>
          </form>
      {
        ticketValue.precio > 0 && event.boletos?.length > 0 && auth.isAuthenticated
          ? (
              <ModalReservation
                event = {event}
                ticketCount = {ticketCount}
                funcion = {functionValue}
                ticket = {ticketValue}
              />
            )
          : <></>
      }
      </div>
    </aside>
  )
}
